<template>
  <b-row
    class="main d-flex align-items-center justify-content-center px-5 w-100"
  >
    <p class="titleForgotPassword w-100">認証コード送信</p>
    <validation-observer ref="validationForm" @submit.prevent="onClickForgotPassword" class="w-100">
      <b-form class="submit-form">
        <validation-provider
          name="メールアドレス"
          rules="required|email"
          mode="passive"
          v-slot="{ errors }"
        >
          <b-form-group id="email-group">
            <input-text-component
              id="email"
              v-model="form.email"
              :autofocus="true"
              :maxlength="50"
              :placeholder="`ご登録メールアドレス`"
              :state="errors && errors.length ? true : false"
              @blur="cleanValidity('email')"
            />
            <span class="text-danger" v-for="(error, i) in errors" :key="i"
              >{{ errors[i] }}
            </span>
          </b-form-group>
        </validation-provider>

        <b-button type="submit" variant="info" class="btn-submit d-flex align-items-center justify-content-center">
          送信
          <span class="material-icons material-icons-outlined">
            keyboard_arrow_right
          </span>
        </b-button>
        <p class="titleDescribe">メールが届かない場合は、メール受信の許可設定（plus-automation.com）または迷惑メールフォルダ等に届いていないかご確認ください。</p>
        <div class="forgot-password confirm-code pl-0">
          <a @click.prevent.stop="$emit('back-to-login')" class="cursor-pointer d-flex justify-content-center"
            >ログインに戻る</a
          >
        </div>
      </b-form>
    </validation-observer>
  </b-row>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import InputTextComponent from '../custom-components/InputTextComponent.vue'
import FlashMessage from '../../common/flash-message.component'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    InputTextComponent
  },
  data() {
    return {
      form: {
        email: ''
      }
    }
  },
  methods: {
    async onClickForgotPassword() {
      const isValid = await this.$refs.validationForm.validate()
      if (!isValid) {
        this.$emit('email-incorrect')
        FlashMessage.getInstance().hideAllMessages()
        return
      }
      const { email } = this.form
      this.$emit('verify-email', email)
    },
    cleanValidity(id) {
      const input = document.getElementById(id)
      if (!input.checkValidity()) {
        input.setCustomValidity('')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.main {
  font-style: normal;
  font-weight: normal;
  @include responsive-fs(12);

  .forgot-password {
    margin-top: 16px;
    @include responsive-fs(12);
  }
  .forgot-password a {
    color: #155275;
  }
  .error-message {
    @include responsive-fs(12);
    line-height: 160%;
    color: #b41b3e;
  }
  .btn-submit {
    width: 100%;
  }
  .form-group input {
    font-family: Inter;
    font-style: normal;
    font-weight: normal;
    color: #252422;
    @include responsive-fs(16);
    border: 1px solid #afafae;
    height: 38px;
  }
  .titleDescribe {
    @include responsive-fs(12);
    margin: 8px 0 0 !important;
  }
  .titleForgotPassword {
    font-weight: bold;
    @include responsive-fs(18);
    margin-bottom: 24px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/user-info/ForgotPassword.vue